import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlus, faEllipsis, faDownload, } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState, useImperativeHandle, forwardRef, } from "react";
import Slider from "react-slick";
import Docmnt from "../../assets/images/google-docs.png";
import { Modal, Button, Alert, Table, Tabs, Tab } from "react-bootstrap";
import { SAVEATTACHMENTS, DELETEATTACHMENTS, DOWNLOADFILES, CONVERTBLOB, HISTORYSAVEATTACHMENTS, } from "../../Utils/conts.js";
import Form from "react-bootstrap/Form";
import Galpic from "../../assets/images/photo.png";
import Bin from "../../assets/images/bin.png";
import Radown from "../../assets/images/radown.png";
import Trash from "../../assets/images/trash.png";

import Arcv from "../../assets/images/archive.svg";
import Export from "../../assets/images/export.svg";

import { withoutRFSToken, withRFSToken } from "../../Services/axios.js";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import { Link } from "@mui/material";
import axios from "axios";
// const ImageUpload = ({ attachable_type, attachable_id, attachments }) => { // OLD
const ImageUpload = forwardRef(
  ({ attachable_type, attachable_id, attachments, onDeleteSuccess, group_id, history, attachment_no, galleryViewId = null }, ref) => {
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedDelFile, setSelectedDelFile] = useState({
      index: null,
      id: null,
    });
    const [activeTab, setActiveTab] = useState('All');
    const handleTabChange = async (tab) => {
      setActiveTab(tab);
    }
    useEffect(() => {
      if (attachments) {
        setFiles(attachments);
      }
    }, [attachments]);
    const handleDrop = (e) => {
      e.preventDefault();
      const droppedFiles = Array.from(e.dataTransfer.files);
      setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };
    const handleDragOver = (e) => {
      e.preventDefault();
    };
    const handleBrowseFiles = (e) => {
      if (e) {
        e.preventDefault();
      }
      fileInputRef.current.click();
    };
    useImperativeHandle(ref, () => ({
      handleBrowseFiles,
    }));

    const [isMulti, setIsMulti] = useState(false);
    const [multiData, setMultiData] = useState({ upload_type: 'S' });
    const multipleUpload = () => {
      setIsMulti(true);
      setShowConfirmation(true);
    };
    const multiDatachange = (e) => {
      const { name, value } = e.target;
      setMultiData(prevFormData => ({
        ...prevFormData,
        [name]: value
      }));
    };
    const handleMultiConfirm = (e) => {
      if (e) {
        e.preventDefault();
      }
      fileInputRef.current.click();
      setShowConfirmation(false);
      setIsMulti(false);
    };

    const handleFileChange = (e) => {
      const selectedFiles = Array.from(e.target.files);
      const filesWithBase64 = [];
      const allBase64 = [];
      selectedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = async () => {
          if (file.size > 26214400) {
            toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
            return;
          }
          filesWithBase64.push({ file, base64: reader.result });
          allBase64.push({ base64: reader.result, file_name: file.name }); // for file name
          if (filesWithBase64.length === selectedFiles.length) {
            let allData;
            let res;
            if (group_id) {
              allData = {
                group_id: group_id,
                attachable_type: attachable_type,
                base64Files: allBase64,
              };
              res = await withRFSToken.post(HISTORYSAVEATTACHMENTS, allData);
            } else if (attachable_type == 'booking_schedule') {
              if (multiData.upload_type == 'S') {
                allData = {
                  attachable_id: attachable_id.bookingtruck_date_id,
                  attachable_type: 'booking_schedule_date',
                  files: allBase64,
                };
              } else {
                allData = {
                  attachable_id: attachable_id.bookingtruck_id,
                  attachable_type: 'booking_schedule',
                  files: allBase64,
                };
              }
              res = await withRFSToken.post(SAVEATTACHMENTS, allData);
            // } else if (attachable_type == 'forwarder_plan_trip') {
            //   allData = {
            //     uld_ids: attachable_id,
            //     attachments: allBase64,
            //   };
            //   res = await withRFSToken.post('forwarder-action/upload-planTrip-attechment', allData);
            } else {
              allData = {
                attachable_id: attachable_id,
                attachable_type: attachable_type,
                files: allBase64,
              };
              res = await withRFSToken.post(SAVEATTACHMENTS, allData);
            }
            if (res.data.response_code == 200) {
              const innerData = res.data.response_data;
              if (group_id) {
                setFiles((prevFiles) => [...prevFiles, ...innerData]);
                const storageData = JSON.parse(localStorage.getItem('MHDetails'));
                if (storageData && storageData.Form) {
                  storageData.Form.attachments = [...storageData.Form.attachments, ...innerData];
                  localStorage.setItem('MHDetails', JSON.stringify(storageData));
                }
              } else if (history) {
                setFiles((prevFiles) => [...prevFiles, ...innerData]);
                const storageData = JSON.parse(localStorage.getItem('MHistory'));
                if (storageData && storageData.ULD) {
                  storageData.ULD.attachments = [...storageData.ULD.attachments, ...innerData];
                  localStorage.setItem('MHistory', JSON.stringify(storageData));
                }
              } else {
                onDeleteSuccess();
              }
              toast.success("Uploaded Successfully");
            } else {
              toast.error(res.data.response_msg);
            }
          }
        };
        reader.readAsDataURL(file);
      });
    };
    const handleFileClick = (file) => {
      setSelectedFile(file);
      setImgShow(true);
    };
    const [galleryViewOpen, setGalleryViewOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);
    const handleDeleteFile = async (index, id, type) => {
      let allData;
      // if (attachable_type == 'forwarder_plan_trip') {
      //   if (isTopDel) {
      //     allData = selectedRows?.map(id => id.attachment_id);
      //   } else {
      //     allData = [selectedDelFile.id];
      //   }
      //   const res = await withRFSToken.post('forwarder-action/delete-planTrip-attechment', { attachment_ids: allData })
      //     .then(function (res) {
      //       if (res.data.response_code == 200) {
      //         toast.success("Deleted Successfully");
      //         onDeleteSuccess();
      //         setSelectedRows([]);
      //         setIsTopDel(false);
      //       } else {
      //         toast.error(res.data.response_msg);
      //       }
      //     });
      // } else {
        if (isTopDel) {
          allData = selectedRows;
        } else {
          allData = [
            {
              attachment_id: selectedDelFile.id,
              attachment_type: selectedDelFile.type,
            },
          ];
        }
        const res = await withRFSToken.post(DELETEATTACHMENTS, { attachment_ids: allData })
          .then(function (res) {
            if (res.data.response_code == 200) {
              toast.success("Deleted Successfully");
              if (group_id) {
                setFiles((prevFiles) => {
                  const newFiles = [...prevFiles];
                  newFiles.splice(index, 1);
                  return newFiles;
                });
                const storageData = JSON.parse(localStorage.getItem('MHDetails'));
                if (storageData && storageData.Form && storageData.Form.attachments) {
                  storageData.Form.attachments.splice(index, 1);
                  localStorage.setItem('MHDetails', JSON.stringify(storageData));
                }
              } else if (history) {
                setFiles((prevFiles) => {
                  const newFiles = [...prevFiles];
                  newFiles.splice(index, 1);
                  return newFiles;
                });
                const storageData = JSON.parse(localStorage.getItem('MHistory'));
                if (storageData && storageData.ULD && storageData.ULD.attachments) {
                  storageData.ULD.attachments.splice(index, 1);
                  localStorage.setItem('MHistory', JSON.stringify(storageData));
                }
              } else {
                onDeleteSuccess();
              }
              // setFiles(prevFiles => {
              //     if (selectedRows.length > 0) {
              //         const selectedIds = new Set(selectedRows.map(row => row.id));
              //         return prevFiles.filter(file => !selectedIds.has(file.id));
              //     } else {
              //         const newFiles = [...prevFiles];
              //         newFiles.splice(index, 1);
              //         return newFiles;
              //     }
              // });
              // if (selectedRows.length > 0) {
              setSelectedRows([]);
              setIsTopDel(false);
              // }
            } else {
              toast.error(res.data.response_msg);
            }
          });
      // }
    };
    const handleClose = () => {
      setImgShow(false);
      setSelectedFile("");
    };
    var settings = {
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
    };
    const handleDeleteImage = (index, id, type) => {
      setSelectedDelFile({ index, id, type });
      setShowConfirmation(true);
      setIsTopDel(false);
    };
    const handleDeleteImageTop = () => {
      if (selectedRows.length > 0) {
        setShowConfirmation(true);
        setIsTopDel(true);
      } else {
        toast.error("Please select at least one image");
      }
    };
    const closeConfirm = () => {
      setShowConfirmation(false);
      setSelectedDelFile({ index: null, id: null });
      setIsTopDel(false);
      setIsMulti(false);
    };
    const handleConfirmation = (confirm) => {
      if (confirm) {
        handleDeleteFile(
          selectedDelFile.index,
          selectedDelFile.id,
          selectedDelFile.type
        );
        setShowConfirmation(false);
      } else {
        closeConfirm();
      }
    };
    function extractPath(url) {
      try {
        let urlObject = new URL(url);
        let path = urlObject.pathname.substring(1);
        return path;
      } catch (error) {
        console.error("Invalid URL:", error);
        return null;
      }
    };
    const handleDownload = async (imageUrl, imageName) => {
      const path = extractPath(imageUrl);
      const res = await withRFSToken
        .post("get-file-blob", {
          file_path: imageUrl,
          // file_path: path,
        })
        .then((response) => {
          const pdfData = atob(response.data.response_data.file_base64);
          const byteNumbers = new Array(pdfData.length);
          for (let i = 0; i < pdfData.length; i++) {
            byteNumbers[i] = pdfData.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: response.data.response_data.mime_type,
          });
          saveAs(blob, imageName);
        })
        .catch((error) => {
          console.error("Error during the file download:", error);
          alert("Could not download the file");
        });
    };
    const showGalleryView = () => {
      setGalleryViewOpen(true);
    };
    const galleryViewclose = () => {
      setGalleryViewOpen(false);
      setSelectedRows([]);
    };
    const handleCheckboxChange = (file, isChecked) => {
      if (isChecked) {
        // setSelectedRows([...selectedRows, file]);
        setSelectedRows((prevSelectedRows) => [
          ...prevSelectedRows,
          { attachment_id: file.id, attachment_type: file.attachment_type },
        ]);
      } else {
        setSelectedRows(
          selectedRows.filter((row) => row.attachment_id !== file.id)
        );
      }
    };
    const multipleDownload = async () => {
      let payload = {};
      if (attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld') {
        payload = {
          uld_number: attachment_no,
          attachments: selectedRows
        }
      } else if (attachable_type == 'service_recovery' || attachable_type == 'service_recovery_handler_feedback') {
        payload = {
          service_recovery_id: attachable_id,
          attachments: selectedRows
        }
      } else {
        payload = {
          uld_number: attachable_id,
          attachments: selectedRows
        }
      }
      const res = await withRFSToken.post(DOWNLOADFILES, payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
          responseType: 'blob', // important for handling binary file download like Excel
        }
      ).then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'attachments.zip';
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.success("Downloaded Successfully");
      });
      // const res = await withRFSToken.post(DOWNLOADFILES, payload) // { uld_number: attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld' ? attachment_no : attachable_id, attachments: selectedRows, }
      //   .then(function (res) {
      //     if (res.data.response_code == 200) {
      //       const downloadUrl = res.data.response_data;
      //       const a = document.createElement("a");
      //       a.href = downloadUrl;
      //       a.download = "download.zip"; // You can set a default filename here
      //       document.body.appendChild(a);
      //       a.click();
      //       document.body.removeChild(a);
      //       toast.success("Downloaded Successfully");
      //     } else {
      //       toast.error(res.data.response_msg);
      //     }
      //   });
    };

    return (
      <>
        <div className={attachable_type === 'missing_uld' ? '' : 'my-3'}>
          <div className="d-flex justify-content-between align-items-center">
            {attachable_type === 'missing_uld' ?
              <h4 className="mb-0">Recovery Case - Attachments ({files.length || 0})</h4>
              :
              <h3 className="mb-0">Attachments ({files.length || 0})</h3>
            }
            <div className="d-flex rightdrop">
              <Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-basic">
                  <FontAwesomeIcon icon={faEllipsis} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1" onClick={showGalleryView}>
                    Open gallery view
                  </Dropdown.Item>{" "}
                  <Dropdown.Item href="#/action-2">Download all</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div onDrop={handleDrop} onDragOver={handleDragOver}>
                <button className="raplas" onClick={attachable_type == 'booking_schedule' ? multipleUpload : handleBrowseFiles}>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  multiple
                />
              </div>
            </div>
          </div>
          <div className="raslider">
            {attachable_type === 'missing_uld' ?
              <>
                <Table className='recovery_table '>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Size</th>
                      <th>Date added</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {files.map((file, index) => {
                      const fileName = file.file_name;
                      const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                      const extension = fileName?.split(".").pop();
                      
                      return (
                        <tr key={`gv${index}`}>
                          <td className="delimg">
                            <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                          </td>
                          <td>
                            {/* {["jpeg", "jpg", "png", "webp"].includes(file.file_path.split(".")[file.file_path.split(".").length - 1] */}
                            {["jpeg", "jpg", "png", "webp"].includes(file.file_type?.toLowerCase()) 
                            ? (
                              <>
                                <img
                                  src={file.file_path}
                                  alt="Preview"
                                  style={{
                                    maxWidth: "22px",
                                    maxHeight: "22px",
                                    marginRight: "5px",
                                  }}
                                  onClick={() => handleFileClick(file.file_path)}
                                />
                                <span>
                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="d-flex rafilename">
                                  <img src={Docmnt} className="fileimg" />
                                  <span>{file.file_name}</span>
                                </span>
                              </>
                            )}
                          </td>
                          <td>{file.file_size}</td>
                          <td>{file.upload_time}</td>
                          <td className="delimg">
                            <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </>
              :
              <>
                <div className="slider-container">
                  {files.length > 2 ? (
                    <>
                      <Slider {...settings}>
                        {files.map((file, index) => {
                          const fileName = file.file_name;
                          const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                          const extension = fileName?.split(".").pop();
                          return (
                            <>
                              <div key={`sl_${index}`} className="slideimg">
                                {["jpeg", "jpg", "png", "webp"].includes(file.file_type?.toLowerCase()) ? (
                                  <>
                                    <div>
                                      <img
                                        src={file.file_path}
                                        alt="Preview"
                                        style={{
                                          maxWidth: "30px",
                                          maxHeight: "30px",
                                          marginRight: "10px",
                                        }}
                                        onClick={() =>
                                          handleFileClick(file.file_path)
                                        }
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <span className="d-flex rafilename">
                                      <img src={Docmnt} className="fileimg" />
                                    </span>
                                  </>
                                )}
                                <span className="rafilename">
                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                </span>
                                <div>
                                  <Link to="#" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                    <FontAwesomeIcon icon={faDownload} />
                                  </Link>
                                  {file.is_comment !== 1 &&
                                    file.is_editable === 1 && (
                                      <button
                                        className="slide_dltbtn mmmm"
                                        type="button"
                                        onClick={() => handleDeleteImage(index, file.id, file.attachment_type)}
                                      >
                                        <FontAwesomeIcon icon={faXmark} color="#656565" />
                                      </button>
                                    )}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </Slider>
                    </>
                  ) : (
                    <>
                      <div className="nonslide">
                        {files.map((file, index) => {
                          const fileName = file?.file_name;
                          const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                          const extension = fileName?.split(".").pop();
                          return (
                            <>
                              <div key={`ns_${index}`} className="slideimg">
                                {["jpeg", "jpg", "png", "webp"].includes(file.file_type?.toLowerCase()) ? (
                                  <>
                                    <img
                                      src={file.file_path}
                                      alt="Preview"
                                      style={{
                                        maxWidth: "30px",
                                        maxHeight: "30px",
                                        marginRight: "10px",
                                      }}
                                      onClick={() =>
                                        handleFileClick(file.file_path)
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <span className="d-flex rafilename">
                                      <img src={Docmnt} className="fileimg" />
                                    </span>
                                  </>
                                )}
                                <span className="rafilename">
                                  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                </span>
                                <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                  <FontAwesomeIcon icon={faDownload} />
                                </Link>

                                {/* {1 === 1 && ( */}
                                {file.is_comment !== 1 &&
                                  file.is_editable === 1 && (
                                    <button
                                      className="slide_dltbtn"
                                      type="button"
                                      onClick={() =>
                                        handleDeleteImage(index, file.id, file.attachment_type)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                  )}
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </>}
            <Modal show={imgShow} onHide={handleClose} centered className="imgmodal">
              <Modal.Header closeButton onClick={handleClose}></Modal.Header>
              <Modal.Body>
                <img src={selectedFile} className="img-fluid" alt="Selected" />
              </Modal.Body>
            </Modal>
            <Modal show={showConfirmation} onHide={closeConfirm} className="addfrom change_type" centered>
              <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
              <Modal.Body>
                {isMulti ?
                  <>
                    <h3>Add Attachment - Recurring Bookingtruck</h3>
                    <p>Do you want to add this attachment only to this booking truck or to all future recurring booking trucks?</p>
                    <div className="frequnt_modal">
                      <Form.Check
                        inline
                        label={`Add to Single Bookingtruck (${attachment_no} - ${attachable_id.date})`}
                        name="upload_type"
                        type='radio'
                        id='S'
                        value="S"
                        checked={multiData.upload_type == 'S'}
                        onChange={multiDatachange}
                      />
                      <Form.Check
                        inline
                        label={`Add to All Future Bookingtrucks (${attachment_no})`}
                        name="upload_type"
                        type='radio'
                        id='M'
                        value="M"
                        checked={multiData.upload_type == 'M'}
                        onChange={multiDatachange}
                      />
                    </div>
                  </>
                  :
                  <>
                    <h3>The Attachment will be destroyed. </h3>
                    <p>Are you sure you want to continue?</p>
                  </>}
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex w-50 mx-auto are_bottom">
                  {isMulti ?
                    <><Button variant="primary" onClick={handleMultiConfirm}> Upload</Button></>
                    :
                    <>
                      <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
                      <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
                    </>
                  }
                </div>
              </Modal.Footer>
            </Modal>
            <Modal show={galleryViewOpen} onHide={galleryViewclose} className="addfrom change_type" centered size="xl">
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <div className="d-flex justify-content-between">
                  <div className="attchment">
                    <h3>
                      {attachable_type === 'acceptance' ? 'Shipment Attachments - ' : attachable_type === 'missing_uld' ? 'Recovery Case - ' : ''}{attachment_no ? attachment_no : (group_id ? '' : attachable_id)}
                      {/* {galleryViewId
                        ? galleryViewId
                        : `${attachable_type === 'acceptance'
                          ? 'Shipment Attachments - '
                          : attachable_type === 'missing_uld'
                            ? 'Recovery Case - '
                            : ''}${attachment_no ? attachment_no : (group_id ? '' : attachable_id)}`
                      } */}
                      <span>
                        Attachments
                        <span className="rabadge badge bg-primary">
                          {attachments?.length}
                        </span>
                      </span>
                    </h3>
                  </div>
                  <div className="gallery_download">
                    <button onClick={handleDeleteImageTop}>
                      <img title="" src={Trash} /> <span>Delete</span>
                    </button>
                    <button onClick={multipleDownload}>
                      <img src={Export} /> <span>Download</span>
                    </button>
                  </div>
                </div>
                <div className="row my-3">
                  {['exp_shipment_record', 'imp_shipment_record'].includes(attachable_type) &&
                    <div className="col-md-2">
                      <ul className="shipment_gl flbg p-2 mb-0">
                        {["Invoice", "Packinglist", "Emails", "HAWB", "MAWB", "Manifest", "Customs", "Proposal", "Other"].map((name) => (
                          <li key={name}>
                            <span>
                              <Form.Check
                                inline
                                label={name}
                                value={name}
                                name="group1"
                                checked={files?.some(chk => chk.category && chk.category.includes(name)) || false}
                              />
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  }
                  {['exp_shipment_record', 'imp_shipment_record'].includes(attachable_type) ?
                    <div className="col-md-10">
                      <div className="flbg gl_tab">
                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="attach_tab">
                          <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                            <Table className="gallery_view">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files.map((file, index) => {
                                  const fileName = file.file_name;
                                  const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                  const extension = fileName?.split(".").pop();
                                  return (
                                    <tr key={`gv${index}`}>
                                      <td>
                                        <Form.Check
                                          type="checkbox"
                                          id="checkbox"
                                          checked={selectedRows.some(
                                            (row) => row.attachment_id === file.id
                                          )}
                                          onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                        />
                                      </td>
                                      <td className="delimg">
                                        <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                      </td>
                                      <td>
                                        {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                        ) ? (
                                          <>
                                            <img
                                              src={file.file_path}
                                              alt="Preview"
                                              style={{
                                                maxWidth: "22px",
                                                maxHeight: "22px",
                                                marginRight: "10px",
                                              }}
                                              onClick={() => handleFileClick(file.file_path)}
                                            />
                                            <span>
                                              {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                            </span>

                                          </>
                                        ) : (
                                          <>
                                            <span className="d-flex rafilename">
                                              <img src={Docmnt} className="fileimg" />
                                              <span>{file.file_name}</span>
                                            </span>
                                          </>
                                        )}
                                        <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                      </td>
                                      <td><p>{file.category[0]}</p></td>
                                      <td><p>{file.modified_name}</p>
                                        <span>{file.modified_email}</span></td>
                                      <td>{file.last_modified}</td>
                                      <td className="delimg">
                                        <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files?.filter(data => ["doc", "docx", "txt"].includes(data.file_ext.toLowerCase()))
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.id
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <span className="d-flex rafilename">
                                            <img src={Docmnt} className="fileimg" />
                                            <span>{file.file_name}</span>
                                          </span>
                                          <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                        </td>
                                        <td>{file.file_type}</td>
                                        <td>{file.file_size}</td>
                                        <td>{file.upload_time}</td>
                                        <td className="delimg">
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files?.filter(data => ["xls", "xlsx", "csv"].includes(data.file_ext.toLowerCase()))
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.id
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <span className="d-flex rafilename">
                                            <img src={Docmnt} className="fileimg" />
                                            <span>{file.file_name}</span>
                                          </span>
                                          <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                        </td>
                                        <td>{file.file_type}</td>
                                        <td>{file.file_size}</td>
                                        <td>{file.upload_time}</td>
                                        <td className="delimg">
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files?.filter(data => ['pdf'].includes(data.file_ext.toLowerCase()))
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.id
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <span className="d-flex rafilename">
                                            <img src={Docmnt} className="fileimg" />
                                            <span>{file.file_name}</span>
                                          </span>
                                          <span>{file.file_size}</span> <span>{file.file_ext}</span>
                                        </td>
                                        <td>{file.file_type}</td>
                                        <td>{file.file_size}</td>
                                        <td>{file.upload_time}</td>
                                        <td className="delimg">
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab eventKey="Images" title={<span>Images </span>} className='moveto'>
                            <Table className='gallery_view'>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Uploaded by</th>
                                  <th>last modified</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {files?.filter(data => ["jpg", "jpeg", "png", "bmp"].includes(data.file_ext.toLowerCase()))
                                  .map((file, index) => {
                                    const fileName = file.file_name;
                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                    const extension = fileName?.split(".").pop();
                                    return (
                                      <tr>
                                        <td>
                                          <Form.Check
                                            type="checkbox"
                                            id="checkbox"
                                            checked={selectedRows.some(
                                              (row) => row.attachment_id === file.id
                                            )}
                                            onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                          />
                                        </td>
                                        <td className="delimg">
                                          <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                        </td>
                                        <td>
                                          <img
                                            src={file.file_path}
                                            alt="Preview"
                                            style={{
                                              maxWidth: "22px",
                                              maxHeight: "22px",
                                              marginRight: "10px",
                                            }}
                                            onClick={() => handleFileClick(file.file_path)}
                                          />
                                          <span>
                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                          </span>
                                        </td>
                                        <td>{file.file_type}</td>
                                        <td>{file.file_size}</td>
                                        <td>{file.upload_time}</td>
                                        <td className="delimg">
                                          <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                          {/* )} */}
                                        </td>
                                      </tr>
                                    )
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                    :
                    <Table className="gallery_view">
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Size</th>
                          <th>Uploaded by</th>
                          <th>last modified</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {files.map((file, index) => {
                          const fileName = file.file_name;
                          const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                          const extension = fileName?.split(".").pop();

                          return (
                            <tr key={`gv${index}`}>
                              <td>
                                <Form.Check
                                  type="checkbox"
                                  id="checkbox"
                                  checked={selectedRows.some(
                                    (row) => row.attachment_id === file.id
                                  )}
                                  onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                />
                              </td>
                              <td className="delimg">
                                <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                              </td>
                              <td>
                                {["jpeg", "jpg", "png", "webp"].includes(extension?.toLowerCase()) ? (
                                  <>
                                    <img
                                      src={file.file_path}
                                      alt="Preview"
                                      style={{
                                        maxWidth: "22px",
                                        maxHeight: "22px",
                                        marginRight: "10px",
                                      }}
                                      onClick={() => handleFileClick(file.file_path)}
                                    />
                                    <span>
                                      {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span className="d-flex rafilename">
                                      <img src={Docmnt} className="fileimg" />
                                      <span>{file.file_name}</span>
                                    </span>
                                  </>
                                )}
                              </td>
                              <td>{file.file_type}</td>
                              <td>{file.file_size}</td>
                              <td>{file.uploaded_by_org_name}</td>
                              <td>{file.upload_time}</td>
                              <td className="delimg">
                                <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  }
                </div>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
          </div>
        </div>
      </>
    );
  }
);

export default ImageUpload;
